import { ADD_D2D_PILL, ADD_D2D_PILL_DONE, ADD_D2D_PILL_ERR, EDIT_D2D_PILL, EDIT_D2D_PILL_DONE, EDIT_D2D_PILL_ERR, EDIT_D2D_PILL_SCHEDULE, REMOVE_D2D_PILL, REMOVE_D2D_PILL_DONE, REMOVE_D2D_PILL_ERR } from './actionTypes';
export const addPill = (data) => ({
    type: ADD_D2D_PILL,
    data
});
export const addPillDone = (data) => ({
    type: ADD_D2D_PILL_DONE,
    data
});
export const addPillError = (data) => ({
    type: ADD_D2D_PILL_ERR,
    errorMessage: data
});
export const editPill = (data) => ({
    type: EDIT_D2D_PILL,
    data
});
export const editPillDone = (data) => ({
    type: EDIT_D2D_PILL_DONE,
    data
});
export const editPillError = (data) => ({
    type: EDIT_D2D_PILL_ERR,
    errorMessage: data
});
export const editPillSchedule = (data) => ({
    type: EDIT_D2D_PILL_SCHEDULE,
    data
});
export const removePill = (data) => ({
    type: REMOVE_D2D_PILL,
    data
});
export const removePillDone = (data) => ({
    type: REMOVE_D2D_PILL_DONE,
    data
});
export const removePillError = (data) => ({
    type: REMOVE_D2D_PILL_ERR,
    errorMessage: data
});
//# sourceMappingURL=actionCreators.js.map